'use strict';

$('.tooltip').on('click', '.js-close', function (event) {
  event.preventDefault();
  $(event.delegateTarget).addClass('hidden');
});
